import IconButton from '@mui/material/IconButton';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

export const FullscreenButton = ({ isFullscreen, onToggle }) => {
  return (
    <IconButton onClick={onToggle} aria-label='toggle fullscreen'>
      {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </IconButton>
  );
};

export default FullscreenButton;
